import * as React from "react"

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} {...props}>
    <g data-name="Group 955">
      <g data-name="Group 684">
        <g
          data-name="Path 196"
          style={{
            fill: "#fff",
          }}
        >
          <path
            d="M11 21.5C5.21 21.5.5 16.79.5 11S5.21.5 11 .5 21.5 5.21 21.5 11 16.79 21.5 11 21.5z"
            style={{
              stroke: "none",
            }}
          />
          <path
            d="M11 1C5.486 1 1 5.486 1 11s4.486 10 10 10 10-4.486 10-10S16.514 1 11 1m0-1c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0z"
            style={{
              fill: "#363636",
              stroke: "none",
            }}
          />
        </g>
      </g>
      <path
        data-name="Path 356"
        d="M84.982 6.563a8.422 8.422 0 1 0 8.418 8.422 8.421 8.421 0 0 0-8.418-8.422zm-2.439 12.38-1.772.246.256-1.772 5.437-5.441 1.53 1.524zm5.757-5.754-1.516-1.519.889-.889 1.52 1.519z"
        transform="translate(-73.98 -3.984)"
        style={{
          fill: "#292929",
        }}
      />
    </g>
  </svg>
)

export default SvgComponent